import { Theme, Alert, Button, SxProps } from '@mui/material';

import useLocales from 'src/hooks/useLocales';

type WorkflowLoadErrorProps = {
  messageLocale: string;
  onRetry: () => void;
  sx?: SxProps<Theme>;
};

export default function WorkflowLoadError({ messageLocale, onRetry, sx }: WorkflowLoadErrorProps) {
  const { t } = useLocales();

  return (
    <Alert
      severity="error"
      sx={sx}
      action={
        <Button color="inherit" size="small" onClick={onRetry}>
          {t('workflows.retry')}
        </Button>
      }
    >
      {t(messageLocale)}
    </Alert>
  );
}
